import axios from '../plugins/axios'

const API_URL = process.env.VUE_APP_API_URL + '/travels/'
class TripsAPI {
  list() {
    return axios
      .get(API_URL)
      .then(response => {
        return response.data
      })
  }
  show(id) {
    return axios
      .get(API_URL + id)
      .then(response => {
        return response.data
      })
  }
  edit(id, data) {
    return axios
      .post(API_URL, {
        _id: id,
        name: data.name,
        description: data.description,
        startDate: data.startDate,
        endDate: data.endDate,
        motorbike: data.motorbike,
        startKm: data.startKm,
        endKm: data.endKm,
        tracks: data.tracks
      })
      .then(response => {
        return response.data
      })
  }
  delete(id) {
    return axios
      .delete(API_URL + id)
      .then(response => {
        return response.data
      })
  }
}
export default new TripsAPI()